export const pageConfig: {
  type_refund: number
} = {
  type_refund: 3
}